module.exports = __webpack_public_path__ + "static/img/why-3.88536cb4.jpg";